export default "__VITE_ASSET__C5K8JxH6__"